import { Mongo } from "meteor/mongo";
import { Blacklist } from "lib";

export const Blacklists = new Mongo.Collection<Blacklist>("blacklist");
